export default __webpack_public_path__ + "static/media/Call_new.03d34ce1.svg";